module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="assetTooltip">\n    <div class="image-wrapper">\n        <img src="' +
__e( thumbnailUrl ) +
'" class="image" title="' +
__e( name ) +
'">\n    </div>\n\n    <div class="image-info">\n        <div class="title">' +
__e( name ) +
'</div>\n        <div class="description">' +
__e( description ) +
'</div>\n    </div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/assets/youtube/YouTubeTooltipTemplate.tpl
// module id = 2080
// module chunks = 0